module.exports = new __parcel__URL__("agent-overview-page-skeleton.tpl.5523a7de.svg").toString();